import React from 'react';

import { useTranslation } from 'react-i18next';
import { NotificationFrequency } from 'components/NotificationsManager/NotificationFrequency/NotificationFrequency';
import './NotificationFormTypeItem.scss';
import { FormInput } from 'ui/FormComponents';
import TooltipInfo from 'pages/Asset/tabs/Monitoring/components/TooltipInfo/TooltipInfo';
import ComingSoonTag from 'components/ComingSoonTag/ComingSoonTag';
import {
  NotificationFormTypeOption,
  useGetNotificationsOptions,
} from './useGetNotificationsOptions';
import { FormMultiSelect } from 'ui/FormComponents/FormMultiSelect';
import { FormCheckbox } from 'ui/FormComponents/FormCheckbox';
import { useFormContext } from 'react-hook-form';

const NotificationFormTypeItem: React.FC<{ notificationType: NotificationFormTypeOption }> = ({
  notificationType,
}) => {
  const { t } = useTranslation();
  const { watch } = useFormContext();
  const { enabled, enable_tooltip, inputs, name } = notificationType;
  const selectsOptions = useGetNotificationsOptions(name);
  const showInputs = enabled && watch(`${name}.selected`);
  return (
    <div className={`notifications-manager-form-type-item ${enabled ? '' : 'disabled'}`}>
      <FormCheckbox
        disabled={!enabled}
        name={`${name}.selected`}
        label={
          <span className="notifications-manager-form-type-item-label">
            {t(`components:notifications_manager.notification_type.${name}.title`)}
            {enable_tooltip && (
              <TooltipInfo>
                {t(`components:notifications_manager.notification_type.${name}.tooltip`)}
              </TooltipInfo>
            )}
            {!enabled && <ComingSoonTag />}
          </span>
        }
      />
      {showInputs && (
        <>
          <NotificationFrequency fieldName={`${name}.frequencies`} />

          {inputs?.map((input) => (
            <div key={input.name} className="notifications-manager-form-type-item-input">
              {input.type === 'select' ? (
                <FormMultiSelect
                  name={`${name}.${input.name}`}
                  selectOptionData={selectsOptions?.[input.name] ?? []}
                  allLabel={t(
                    `components:notifications_manager.notification_type.${name}.${input.name}.all`,
                  )}
                  disabled={selectsOptions?.[input.name]?.length === 0}
                />
              ) : (
                <FormInput
                  name={`${name}.${input.name}`}
                  label={t(
                    `components:notifications_manager.notification_type.${name}.${input.name}.text`,
                  )}
                />
              )}
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default NotificationFormTypeItem;
